import React, { useEffect, useState } from 'react';
import { useUploadedDriverList } from '../../hooks/react-query/useDrivers';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/Table';
import { Mapper } from '../../utils/importDriver/mapper';
import { FolderOpenIcon } from '../../icons';
import Container from '../elements/container';
import { TableSkeletion } from '../elements/skeletions';
import { Rounded } from '../elements/rounded';
import { NoDataFound } from '../elements/noDataFound';
import Loader from '../elements/loader';
import clsx from 'clsx';

const ImportDriverTable = ({ handleExpendClick }) => {
  const [tableData, setTableData] = useState();
  const { data: driverList, isSuccess, isLoading } = useUploadedDriverList();

  useEffect(() => {
    if (driverList) {
      setTableData(Mapper(driverList));
    }
  }, [isSuccess, driverList, driverList?.data]);

  if (isLoading && !tableData) {
    return (
      <Container className="max-lg:px-0">
        <TableSkeletion />
      </Container>
    );
  }

  if (!tableData || !tableData?.data) {
    return (
      <Container className="max-lg:px-0">
        <NoDataFound />
      </Container>
    );
  }

  const createHeaders = () => {
    let headers = [];
    let columns = tableData.columns;
    if (columns && columns.length) {
      columns.map((itm) => {
        let headerTemplate = itm.label;

        headers.push(
          <TableHead scope="col" key={itm.name} className="px-0">
            <p className="whitespace-nowrap text-body text-center font-[700]">
              {headerTemplate}
            </p>
          </TableHead>
        );
      });

      return (
        <TableHeader>
          <TableRow>{headers}</TableRow>
        </TableHeader>
      );
    }
  };

  const createBody = () => {
    let rows = [];

    if (tableData?.data && tableData.data.length) {
      tableData?.data.forEach((itm) => {
        let cells = [];
        let itmComponent;
        const columns = tableData.columns;
        columns.forEach((column) => {
          itmComponent = itm[column.name] || '';
          if (column.name === 'collapseAll') {
            itmComponent = (
              <button type="button" onClick={() => handleExpendClick(itm)}>
                <Rounded className="border border-fadedgrey p-3 flex items-center justify-center">
                  <FolderOpenIcon />
                </Rounded>
              </button>
            );
          } else if (column.name === 'reason') {
            itmComponent = (
              <a className={clsx("font-[600]", itm.unsuccessful && 'text-primary')}>
                {itmComponent}
              </a>
            );
          }

          cells.push(
            <TableCell
              key={column.name} // change it
            >
              <div className="body-text whitespace-nowrap text-center"> {itmComponent}</div>
            </TableCell>
          );
        });

        rows.push(<TableRow className={itm.unsuccessful !== 0 && 'bg-primary/10'} key={itm.id}>{cells}</TableRow>);
      });

      return <TableBody>{rows}</TableBody>;
    }
    return (
      <TableBody>
        <NoDataFound className="flex p-2 items-center justify-center" />
      </TableBody>
    );
  };

  return (
    <>
      {isLoading && tableData && <Loader />}
      <Container className="max-lg:px-0 flex flex-col gap-4">
        <h2>Ιστορικό Καταχωρίσεων</h2>
        <Table wrapperClassName="max-h-[50vh] lg:p-4 p-2 scrollbar overflow-auto rounded-none lg:rounded-[12px]">
          {createHeaders()}
          {createBody()}
        </Table>
      </Container>
    </>
  );
};

export default ImportDriverTable;
